import { Text, Skeleton } from "@chakra-ui/react";
import { Tooltip } from "@/components/ui/tooltip";
import { useDiscordServers } from "../../hooks";

interface Props {
  serverId?: string;
  textStyle?: React.CSSProperties;
}

export const DiscordServerName = ({ serverId, textStyle }: Props) => {
  const { data, status, error } = useDiscordServers();

  const matched = data?.results.find(({ id }) => {
    return id === serverId;
  });

  if (status === "pending") {
    return <Skeleton height="1em" width="80px" display="inline-block" />;
  }

  if (error) {
    return (
      <Tooltip
        positioning={{ placement: "bottom-start" }}
        content={`Unable to get server name (${error?.message})`}
      >
        <Text color="text.warning">{serverId}</Text>
      </Tooltip>
    );
  }

  return <span style={textStyle}>{matched?.name || serverId || "?"}</span>;
};
